<template lang="html">
  <div class="d-flex flex-col" style="margin: 16px 32px;min-width:1300px;">
    <div class="row" style="max-width: 100%; width: 100%;">
      <div class="page-title-container mb-4">
        <div class="row">
          <div class="col-12 col-md-8 mb-3 mb-md-0">
            <h1 class="mb-0 pb-0 display-4" id="title">Liens Externe</h1>
          </div>
          <div class="col-12 col-md-4 d-flex justify-content-end">
            <button
                type="button"
                class="btn btn-primary"
                @click="openAddLinkModal">
              <i class="bi bi-plus-circle" style="margin-right: 8px;"></i> Ajouter un lien
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div
            v-for="link in links"
            :key="link.uid"
            class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="card mt-2" style="border-radius:16px;">
            <div class="card-body">
              <div class="mb-1 content">
                <h5 class="card-title">{{ link.label }}</h5>
                <button class="btn btn-outline-primary" @click="openEditLinkModal(link)">
                  <i class="bi bi-pencil"></i>
                </button>
              </div>
              <p class="card-text">{{ link.href }}</p>
              <div class="d-flex m-2 content">
                <a :href="link.href" target="_blank" class="btn btn-outline-primary">
                  <i class="bi bi-link-45deg"></i> Ouvrir
                </a>

                <button :disabled="loading" class="btn btn-outline-danger" @click="deleteLink(link.uid)">
                  <i class="bi bi-trash"></i> Supprimer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showAddLinkModal" class="modal show d-block" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ isEditing ? 'Modifier le lien' : 'Ajouter un nouveau lien' }}</h5>
              <button type="button" class="btn-close" @click="closeAddLinkModal"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="label" class="form-label">Label</label>
                <input type="text" class="form-control" id="label" v-model="newLink.label">
              </div>
              <div class="mb-3">
                <label for="href" class="form-label">URL</label>
                <input type="text" class="form-control" id="href" v-model="newLink.href">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeAddLinkModal">Annuler</button>
              <button :disabled="loading" type="button" class="btn btn-primary"
                      @click="isEditing ? updateLink() : addLink()">
                {{ isEditing ? 'Mettre à jour' : 'Ajouter' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LINKS from '@/gql/queries/links.graphql'
import ADD_LINK from '@/gql/mutations/addLink.graphql'
import UPDATE_LINK from '@/gql/mutations/updateLink.graphql'
import DELETE_LINK from '@/gql/mutations/deleteLink.graphql'
import { gqlQuery, gqlMutation } from '@/gqlClient.js'

export default {
  name: 'Link',
  data() {
    return {
      links: [],
      loading: false,
      showAddLinkModal: false,
      isEditing: false,
      newLink: {
        uid: null,
        label: '',
        href: ''
      }
    };
  },
  async mounted() {
    await this.fetchLinks();
  },
  methods: {
    async fetchLinks() {
      const r = await gqlQuery(LINKS, {});
      if (r.ok) {
        this.links = r.body.data.link_set;
      }
    },
    openAddLinkModal() {
      this.isEditing = false;
      this.showAddLinkModal = true;
      this.newLink = { uid: null, label: '', href: '' };
    },
    openEditLinkModal(link) {
      this.isEditing = true;
      this.newLink = { ...link };
      this.showAddLinkModal = true;
    },
    closeAddLinkModal() {
      this.showAddLinkModal = false;
      this.newLink = { uid: null, label: '', href: '' };
    },
    async addLink() {
      this.loading = true;
      try {
        const r = await gqlMutation(ADD_LINK, { label: this.newLink.label, href: this.newLink.href });
        if (r.ok) {
          this.links.push(r.body.data.create_link.link);
          this.closeAddLinkModal();
        } else {
          console.error('Error adding link:', r.error);
        }
      } finally {
        this.loading = false;
      }
    },
    async updateLink() {
      this.loading = true;
      try {
        const r = await gqlMutation(UPDATE_LINK, { uid: this.newLink.uid, label: this.newLink.label, href: this.newLink.href });
        if (r.ok) {
          await this.fetchLinks();
          this.closeAddLinkModal();
        } else {
          console.error('Error updating link:', r.error);
        }
      } finally {
        this.loading = false;
      }
    },
    async deleteLink(uid) {
      this.loading = true;
      try {
        const response = await gqlMutation(DELETE_LINK, { uid });
        if (response.ok) {
          this.links = this.links.filter(link => link.uid !== uid);
        } else {
          console.error('Error deleting link:', response.error);
        }
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 0.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
    
